import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../authentication/authentication.service';
import 'rxjs/add/operator/filter';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { ProfileService } from 'src/app/profile/profile.service';
import { NotificationBuilder } from 'src/app/shared/notificationBuilder';

declare var $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.css']

})

export class AdminLayoutComponent implements OnInit {
    location: Location;
    private _router: Subscription;
    profilePlan: any;
    hasPlatform: boolean = false;
    storePlatform: string = "";
    @ViewChild('sidebar') sidebar;
    @ViewChild(NavbarComponent) navbar: NavbarComponent;

    constructor(private router: Router, location: Location, private notificationBuilder: NotificationBuilder,private authenticationService: AuthenticationService, private profileService: ProfileService) {
        this.location = location;
    }

    ngOnInit() {
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {
            this.navbar.sidebarClose();
        });

        this.storePlatform = localStorage.getItem("storePlatform");
        this.hasPlatform = this.storePlatform != "";

        var isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;
        if (isWindows) {
            var $main_panel = $('.main-panel');
            $main_panel.perfectScrollbar();
        }

        this.profilePlan = this.authenticationService.getProfilePlanInfo();
        if (this.profilePlan == null) {
            this.profileService.GetProfilePlanInfo().subscribe(res => {
                debugger
                if (res.success) {
                    this.authenticationService.setProfilePlanInfo(res.data);
                    this.profilePlan = res.data;
                    if (this.profilePlan.isBlocked){
                        this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
                        this.authenticationService.logout();
                        return;
                    }
                    console.log(this.profilePlan)
                    if ((this.profilePlan.showAlertMessage || this.profilePlan.planSeoName == 'trial') && this.hasPlatform){
                        debugger
                        setTimeout(() => {
                            $(".sidebar").css("top", "40px");
                            $(".main-panel").css("top", "50px");
                        }, 1000);
                    }
                    
                }
            })
        }
        else {
            if (this.profilePlan != null && this.profilePlan.isBlocked){
                this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
                this.authenticationService.logout();
                return;
            }
            if ((this.profilePlan.showAlertMessage || this.profilePlan.planSeoName == 'trial' && this.hasPlatform)){
                setTimeout(() => {
                    $(".sidebar").css("top", "40px");
                    $(".main-panel").css("top", "50px");
                }, 1000);
            }
        }

    }

    public isMap() {
        if (this.location.prepareExternalUrl(this.location.path()) == '/maps/fullscreen') {
            return true;
        }
        else {
            return false;
        }
    }
}
